const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/logo.png"
    {...props}
  />
);

export default Logo;
